<template>
<div class="card" v-loading.fullscreen.lock="loader">
  <div class="section-heading" align="center">CREATE DUMMY USERS</div>
  <br>
  <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="top">
    <el-row>
      <el-col :span="11">
        <el-form-item label="Select Campus" prop="role">
          <el-select v-model="form.role" placeholder="Select Campus">
            <el-option
              v-for="(item, key) in surveyRolesList"
              :key="key"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item label="User's Count" prop="users_count">
          <el-select v-model="form.users_count" placeholder="Select User's Count">
            <el-option
              v-for="(item, key) in count_arr"
              :key="key"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <br>
    <el-row>
      <el-col>
        <el-form-item label="Enter Emails" prop="emails" >
          <el-input placeholder="abc@gmail.com,pqr@yahoo.com,etc..." v-model="form.emails" multiple>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <br>
  <div align="right">
    <el-button class="btn-theme" @click="AddUsers('form')">Add Users</el-button>
  </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AssignDummyUser',
  data () {
    var validateEmails = (rule, value, callback) => {
      if (value) {
        var arr = value.split(', ')
        arr.forEach(ele => {
          var atpos = ele.indexOf('@')
          var dotpos = ele.lastIndexOf('.')
          if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= ele.length) {
            callback(new Error('Please input correct email id'))
          }
        })
        callback()
      } else {
        callback(new Error('Enter Email Id'))
      }
    }
    return {
      surveyRolesList: ['Add New Campus'],
      loader: false,
      count_arr: ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100'],
      form: {
        role: '',
        users_count: '',
        emails: ''
      },
      rules: {
        role: [
          { required: true, message: 'Select Campus Name', trigger: 'change' }
        ],
        users_count: [
          { required: true, message: 'Select Users Count', trigger: 'change' }
        ],
        emails: [
          { validator: validateEmails, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getSurveyRoles: 'Survey/getSurveyRoles',
      getRole: 'Survey/getRole',
      getDummyUser: 'Survey/getDummyUser'
    })
  },
  methods: {
    ...mapActions({
      fetchSurveyRoles: 'Survey/fetchSurveyRoles',
      createRole: 'Survey/createRole',
      addDummyUser: 'Survey/addDummyUser'
    }),
    AddUsers (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var EmaiArr = this.form.emails.split(', ')
          this.loader = true
          this.addDummyUser({
            users_count: this.form.users_count,
            roles: this.form.role,
            emails: EmaiArr
          })
        }
      })
    }
  },
  watch: {
    getSurveyRoles (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.surveyRolesList = []
        console.log('ctreateee', value.data)
        var arr = Object.keys(value.data)
        console.log('arrrrr', arr)
        arr.forEach(ele => {
          this.surveyRolesList.push(ele)
        })
        console.log('Survey', this.surveyRolesList)
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    },
    getDummyUser (value) {
      this.$refs['form'].resetFields()
      this.dialogRole = false
      this.loader = false
      if (value.success === true) {
        this.$message.success(value.message)
      } else {
        this.$message.error(value.message)
      }
    }
  },
  mounted () {
    this.fetchSurveyRoles()
    this.loader = true
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/User/AssignDummyUser.vue